import { Button } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
var REWARD_ALERT_DURATION = 'long';
export var addSuccess = function addSuccess(onUndo, t) {
  return {
    severity: 'success',
    message: t('The reward has been added to your wishlist'),
    duration: REWARD_ALERT_DURATION,
    action: /*#__PURE__*/_jsx(Button, {
      color: "inherit",
      size: "small",
      onClick: onUndo,
      children: t('Undo')
    })
  };
};
export var addFailure = function addFailure(onRetry, t) {
  return {
    severity: 'error',
    message: t('Sorry, we were unable to add this reward to your wishlist'),
    duration: REWARD_ALERT_DURATION,
    action: /*#__PURE__*/_jsx(Button, {
      color: "inherit",
      size: "small",
      onClick: onRetry,
      children: t('Retry')
    })
  };
};
export var removeSuccess = function removeSuccess(onUndo, t) {
  return {
    severity: 'success',
    message: t('The reward has been removed from your wishlist'),
    duration: REWARD_ALERT_DURATION,
    action: /*#__PURE__*/_jsx(Button, {
      color: "inherit",
      size: "small",
      onClick: onUndo,
      children: t('Undo')
    })
  };
};
export var removeFailure = function removeFailure(onRetry, t) {
  return {
    severity: 'error',
    message: t('Sorry, we were unable to remove this reward from your wishlist'),
    duration: REWARD_ALERT_DURATION,
    action: /*#__PURE__*/_jsx(Button, {
      color: "inherit",
      size: "small",
      onClick: onRetry,
      children: t('Retry')
    })
  };
};
var rewardSuccessMessage = 'Your redemption request has been sent to the admin. Keep an eye out for any updates!';
var perkSuccessMessage = 'The gift has been accepted';
export var rewardSuccess = function rewardSuccess(isPerk, t) {
  return function () {
    return {
      severity: 'success',
      message: isPerk ? t(perkSuccessMessage) : t(rewardSuccessMessage),
      duration: REWARD_ALERT_DURATION
    };
  };
};
var rewardFailureMessage = 'Sorry, we were unable to process your redemption';
var perkFailureMessage = 'Sorry, we were unable to redeem this gift';
export var rewardFailure = function rewardFailure(isPerk, onRetry, t) {
  return {
    severity: 'error',
    message: isPerk ? t(perkFailureMessage) : t(rewardFailureMessage),
    duration: REWARD_ALERT_DURATION,
    action: /*#__PURE__*/_jsx(Button, {
      color: "inherit",
      size: "small",
      onClick: onRetry,
      children: t('Retry')
    })
  };
};
export var unknownFailure = function unknownFailure(t) {
  return {
    severity: 'error',
    message: t('Sorry, we were unable to process your redemption'),
    duration: REWARD_ALERT_DURATION
  };
};